import { AUTH_API, handleApiError } from '../../utils/axios';

export const getTasks = async (search, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/tasks?search=${search.search}`
      : `/api/v1/tasks?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createTask = async (task) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/tasks`, task);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateTask = async (task) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/tasks/${task.id}`, task);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteTask = async (taskId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/tasks/${taskId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
